import React, { useRef } from "react";
import ReactDOMServer from "react-dom/server";
import { Box, Card } from '@curves/ui-base';

import useEChart from "@Util/hook/useEChart";
import ChartSkeletonLoading from "@Local/Dashboard/Components/ChartSkeletonLoading";
import { adaptBar } from "@Local/Dashboard/dashboard.util";
const TooltipComponent = ({ axisValue, value }) => {
	return (
		<React.Fragment>
			<div style={{ fontWeight: 600 }}>{axisValue}</div>
			<div>會員人數：{value} 人</div>
		</React.Fragment>
	);
};
/********* 累計運動次數分布 *********/
const TotalWorkoutCountDistribution = React.forwardRef((props, ref) => {
	const chartDomRef = useRef(null);
	const {
		sourceData = {
			xAxis: ["100次以下", "101~200次", "201~300次", "301~400次", "401~500次", "501~600次", "601~700次", "701~800次"],
			data: [150, 85, 65, 48, 38, 28, 18, 12],
		},
	} = props;
	const { data = [], axisLabels = [] } = adaptBar(sourceData);
	const isLoading = data.length === 0;
	const title = "累計運動次數分布";
	const subTitle = "總運動量分布趨勢";
	const option = {
		title: {
			text: title,
			subtext: subTitle,
			left: 24,
			top: 20,
			textStyle: {
				fontSize: 20,
				fontWeight: 600,
				color: "#1F2937",
			},
			subtextStyle: {
				fontSize: 14,
				color: "#64748B",
				padding: [8, 0, 0, 0],
			},
		},
		grid: {
			left: 60,
			right: 40,
			top: 100,
			bottom: 60,
		},
		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "shadow",
			},
			backgroundColor: "#111827",
			borderRadius: 6,
			padding: 10,
			textStyle: {
				color: "#F9FAFB",
				fontSize: 13,
			},
			formatter: params => {
				const item = params[0];
				return ReactDOMServer.renderToStaticMarkup(<TooltipComponent axisValue={item.axisValue} value={item.value} />);
			},
		},
		xAxis: {
			type: "category",
			data: axisLabels,
			axisLine: {
				lineStyle: {
					color: "#000000",
				},
			},
			axisTick: { show: false },
			axisLabel: {
				color: "#374151",
				fontSize: 12,
				align: "center",
				margin: 10,
			},
		},
		yAxis: {
			type: "value",
			axisLine: { show: false },
			axisTick: { show: false },
			axisLabel: {
				color: "#6B7280",
				fontSize: 12,
			},
			splitLine: {
				lineStyle: {
					type: "dashed",
					color: "#E5E7EB",
				},
			},
		},
		series: [
			{
				type: "bar",
				data: data,
				barWidth: 44,
				itemStyle: {
					borderRadius: [8, 8, 0, 0],
					color: "#5B0F74",
				},
				emphasis: {
					itemStyle: {
						color: "#7C1FA0",
					},
				},
			},
		],
	};
	useEChart(chartDomRef, option);
	return (
		<Card style={{ width: "100%", height: "100%" }}>
			<Card.CardContent style={{ width: "100%", height: "100%" }}>
				{isLoading ? <ChartSkeletonLoading /> : <Box ref={chartDomRef} style={{ width: "100%", height: "100%" }}></Box>}
			</Card.CardContent>
		</Card>
	);
});
export default TotalWorkoutCountDistribution;
